import { createFileRoute } from '@tanstack/react-router'
import { ComplianceDashboard } from '../../../features/admin/ComplianceDashboard'

/* ───── Route Definition ───── */

export const Route = createFileRoute('/_authenticated/admin/compliance')({
  component: AdminComplianceRoute,
})

/* ───── Route Component ───── */

function AdminComplianceRoute() {
  return <ComplianceDashboard />
}
